/* eslint-disable react/jsx-max-props-per-line */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import validate from 'validate.js';
import { DialogDefaultV2, NsirStatusSelectV2 } from '../../../components/v2';

const StatusModal = ({
  open,
  handlerCancel,
  handlerConfirm,
  title = 'Reabrir NSIR',
  defaultStatus = null,
}) => {
  const [errors, setErrors] = useState({});
  const [values, setValues] = useState({ status: null });

  useEffect(() => {
    if (defaultStatus) setValues({ status: defaultStatus });
  }, [defaultStatus]);

  const clearForm = () => {
    setErrors({});
    setValues({ status: null });
  };

  const onCancelLocal = () => {
    clearForm();
    handlerCancel();
  };

  const onConfirmLocal = () => {
    const validationErrors = validate(values, {
      status: {
        presence: { allowEmpty: false, message: 'é obrigatório' },
      },
    });
    setErrors(validationErrors || {});
    if (!validationErrors || Object.keys(validationErrors).length === 0) {
      clearForm();
      handlerConfirm(values.status);
    }
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={onCancelLocal}
      handlerConfirm={onConfirmLocal}
      title={title}
      confirmMessage="Salvar"
      maxWidth="md"
    >
      <Grid container spacing={1} sx={{ pt: 1 }}>
        <Grid size={{ xs: 12 }}>
          <NsirStatusSelectV2
            isRequired
            error={!!(errors && errors.status)}
            onSelect={(status) => setValues({ status })}
            value={values.status}
          />
        </Grid>
      </Grid>
    </DialogDefaultV2>
  );
};

StatusModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handlerCancel: PropTypes.func.isRequired,
  handlerConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  defaultStatus: PropTypes.string,
};

export default StatusModal;
